module.exports = __webpack_public_path__ + "img/dienteFinal.faecb99a.svg";